import mapValues from 'lodash/mapValues';
import moment from 'moment';
import {javaApiFor} from 'sources/api';
import {Metric, MetricAxis, MetricData, MetricResponse} from '@store/@types/metric';

const metricTargetApi = javaApiFor(`/api/dashboard/trend/team`);

export interface FetchMetricReq {
  startDate: string;
  endDate: string;
  metric: Metric;
  metricAxis: MetricAxis;
  teams?: string[];
  direction?: 'any' | 'review' | 'coach';
  context?: string;
}

export default class NineBoxMetricSource {
  static fetchMetric({metric, metricAxis, ...params}: FetchMetricReq): Promise<MetricResponse> {
    return metricTargetApi.getJson(`/${metric}`, {params}).then((metricData: MetricData) => {
      return {
        data: mapValues(metricData, repData => ({
          data: repData!.data.map(el => ({
            date: moment(el.date),
            value: el.value,
          })),
        })),
        metricAxis,
      };
    });
  }
}
